import axios from "axios";
import { AuthData } from "../types/types";
import { attachSentryResponseInterceptor } from "./sentryAxiosInterceptor";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_PLATFORM_FEEDBACK_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const localAuth = localStorage.getItem("allaria-auth");

    const parsedLocalAuth: AuthData | null =
      (localAuth && JSON.parse(localAuth)) ?? null;

    const token = parsedLocalAuth?.access_token;

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
attachSentryResponseInterceptor(axiosInstance);

interface FeedbackEmailRequest {
  feedback: string;
}

export const feedback = async ({ feedback }: FeedbackEmailRequest) =>
  (await axiosInstance.post("/feedback", { feedback })).data;
